import React from "react";
import ReactDOM from "react-dom";
import EmbAppliqueGuide from "../embAppliqueGuide";

class EmbGuide {
  constructor() {
    this.renderReactMeta(); // Ensure renderReactMeta is called
  }

  renderReactMeta() {
    const productMetaElement = document.getElementById("emb-applique-guide");
    if (productMetaElement) {
      ReactDOM.render(<EmbAppliqueGuide />, productMetaElement);
    }
  }
}

const EmbGuideInit = {
  init() {
    // If element exists, init this class
    const embElem = [].slice.call(
      document.querySelectorAll(".emb-applique-guide")
    );
    if (embElem) {
      new EmbGuide();
    }
  },
};

export default EmbGuideInit;
